import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "院线大片 · 经典佳作 · 高清画质",
  },
  {
    type: "tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热播剧集 · 持续更新 · 追剧不停",
  },
  {
    type: "variety",
    icon: "ri-mic-line",
    title: "综艺",
    desc: "真人秀 · 音乐舞台 · 轻松治愈",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors duration-300 hover:border-primary-500/60"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-accent-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${entry.icon} text-2xl`} />
          </span>
          <div className="min-w-0">
            <h3 className="font-heading text-lg font-600 text-foreground-950 transition-colors group-hover:text-accent-500">
              {entry.title}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{entry.desc}</p>
          </div>
          <span className="ml-auto flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300/60 text-foreground-500 transition-colors group-hover:border-accent-500 group-hover:text-accent-500">
            <i className="ri-arrow-right-line" />
          </span>
        </Link>
      ))}
    </div>
  );
}